// extracted by mini-css-extract-plugin
export default {"TextCurveControlsContainer":"TextCurveControls_TextCurveControlsContainer__X80-y"};